<template>
  <div class="client-container">
    <div :style="{ overflow: 'hidden' }">
      <bread-crumb :style="{ float: 'left' }" />
      <table-search
        :style="{ float: 'right' }"
        @onSearch="onSearch"
        @onChangeRank="onChangeRank"
        @onChangeSection="onChangeSection"
		    @onChangecompany="onChangecompany"
        @editAndAdd="editAndAdd"
        @importShow="importShow"
      />
    </div>
    <div class="global-table-container">
      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        @change="changePage"
      >
	 
        <template
          slot="doctor_task_count"
          slot-scope="text, record"
        >
          <a @click="handleList(record)">{{ record.doctor_task_count }}</a>
        </template>
        <template
          slot="promoters_count"
          slot-scope="text, record"
        >
          <a @click="handlePromoters(record)">{{ record.promoters_count }}</a>
        </template>
        <template
          slot="company_score"
          slot-scope="text, record"
        >
          <a @click="handleScore(record)">{{ record.company_score }}</a>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            v-if="record.check_status===2"
            href="javascript:;"
            @click="() => handleApprove(record)"
          >认证</a>
          <a-divider
            v-if="record.check_status===2"
            type="vertical"
          />
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            :text="record.user_status===1?'禁用':'启用'"
            :alert-title="record.user_status===1?'确定禁用？':'确定启用？'"
            @onDelete="() => onConfirm(record)"
          />
        </template>
      </a-table>
    </div>
    <add-edit-modal
      ref="formRef"
      :title="title"
      :visible="visible"
      :type-id="typeId"
	  :company_id="company_id"
      :hospital-name="hospitalName"
      @onCancel="onCancel"
      @addhospitalname="addhospitalname"
    >
      <form-button
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancel"
        @onSubmit="onSubmit"
      />
    </add-edit-modal>
    <promoter-list
      :data="promoteData"
      :visible="visiblePromote"
      @onCancel="onCancelPromote"
    >
      <form-button
        :show-msg="false"
        @onCancel="onCancelPromote"
        @onSubmit="onCancelPromote"
      />
    </promoter-list>
    <promoters-list
      :data="promotersData"
      :visible="visiblePromoters"
      @onCancel="onCancelPromoters"
    >
      <form-button
        :show-msg="false"
		submitText="确定"
        @onCancel="onCancelPromoters"
        @onSubmit="onCancelPromoters"
      />
    </promoters-list>
    <approve-modal
      ref="approveRef"
      :data="approveData"
      :visible="visibleApprove"
      @onCancel="onCancelApprove"
    >
      <form-button
        :show-msg="false"
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancelApprove"
        @onSubmit="onSubmitApprove"
      />
    </approve-modal>
    <score-modal
      :data="scoreData"
      :visible="visibleScore"
      @onCancel="onCancelScore"
    >
      <form-button
        :show-msg="false"
        :btn-is-loading="btnIsLoading"
        @onCancel="onCancelScore"
        @onSubmit="onCancelScore"
      />
    </score-modal>
	
	<a-modal class="client-modal-wrapper hospital-modal" :destroy-on-close="true" width="1400px" :mask-closable="false"
		:visible="ImportReadhospitalVisible" :footer="null" title="导入医生" @cancel="onCancel1">
		
		<a-upload
		  name="upload"
		  style="margin-right:20px"
		  :with-credentials="false"
		  :data="{fileType:'file',}"
		  :action="`${uploadUrl}fileup/upload`"
		  @change="(event)=>importDoctors(event)"
		>
		  <a-tooltip
		    placement="bottom"
		  >
		    <template
		      slot="title"
		    >
		      <span>提示：按照模板格式导入</span>
		    </template>
		    <a-button shape="round">
		      <a-icon type="upload" /> 批量导入医生
			  
		    </a-button>
		  </a-tooltip>
		</a-upload>
		<div>支持上传xls和xlsx格式文件，不超过10M，<a href="javascript:;" @click="xiazai">点击下载Excel模板</a>。请按模板格式录入数据，格式错误将导致导入失败。【本次导入成功 {{successNum}} 条，失败 {{failNum}} 条；已存在 {{hadNum}} 条】</div>
		<div>
			<a-table
			:scroll="{y: 500,x: 1000}"
			  :columns="columns1"
			  :data-source="data1"
			  :loading="loading1"
			  :row-key="record => record.line"
			  :pagination="false"
			  class="yc"
			>
			  <template
			    slot="error_msg"
			    slot-scope="text, record"
			  >
			    <div v-if="record.error==true" style="color: red;">{{ record.error_msg}}</div>
				 <div v-if="record.error!==true" >{{ record.error_msg}}</div>
			  </template>
			</a-table>
		</div>
	</a-modal>
  </div>
</template>
<script>
import {columns,columns1,} from './data/index';
import TableSearch from './components/search';
import addEditModal from './modal/index';
import PromoterList from './modal/promoterList.vue';
import PromotersList from './modal/promoters.vue';
import ApproveModal from './modal/approveModal.vue';
import ScoreModal from './modal/scoreList.vue';
export default {
  components: {TableSearch, addEditModal, PromoterList, ApproveModal, PromotersList, ScoreModal},
  data() {
    return {
		successNum:'-',
		failNum:'-',
		hadNum:'-',
		ImportReadhospitalVisible:false,
      columns,
	  columns1,	
      data: [],
	  data1: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
	  loading1: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      typeId: '',
	 
      id: '',
      promoteData: [],
      visiblePromote: false,
      visibleApprove: false,
      btnIsLoadingApprove: false,
      approveData: {},
      check_status: '',
      doctor_status: '',
      professional: '',
	  company_id:'',
      department: '',
      promotersData: [],
      visiblePromoters: false,
      hospitalName: '',
      scoreData: [],
      visibleScore: false,
      doctor_id: '',
	  token:''
    };
  },
  mounted() {
	   this.token=localStorage.getItem('token');
	  this.getCompanyList()
   
	
  },
  methods: {
    // 医院名称回填
    addhospitalname(data){
      console.log('data', data);
      this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
    },
	// 获取合作企业
	async getCompanyList() {
		let result = await this.$http.post('/Company/getCooperationCompanyList');
		if (result.data.status === 1) {
			this.company_id=result.data.data.data_list[0].id
			// 获取表格数据
			this.getTableData({page: this.current, pageSize: this.pageSize,
			  keyword: this.keyword, check_status: this.check_status,
			  doctor_status: this.doctor_status, department: this.department,
			  professional: this.professional,
			  cooperation_company_id: result.data.data.data_list[0].id,
			});
		}
	},
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/doctor/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            user_status: item.user_status,
            user_nickname: item.user_nickname,
            user_realname: item.user_realname,
            mobile: item.mobile,
            hospital: item.hospital,
            department_name: item.department_name,
            professional_name: item.professional_name,
            doctor_status: item.doctor_status,
            check_status: item.check_status,
            doctor_task_count: item.doctor_task_count,
            promoters_count: item.promoters_count,
            company_score: item.company_score,
            qualification_type: item.qualification_type,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
		cooperation_company_id: this.company_id,
      });
    },
    // 选择科室
    onChangeSection(value){
      this.current=1;
      this.department=value;
      console.log('onChangeActiva -> value', value);
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
		cooperation_company_id: this.company_id,
      });
    },

    // 选择职称
    onChangeRank(value){
      this.current=1;
      console.log('onChangeActiva -> value', value);
      this.professional=value;
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
		    cooperation_company_id: this.company_id,
      });
    },
	onChangecompany(value){
	  this.current=1;
	  console.log('onChangeActiva -> value', value);
	  this.company_id=value;
	  this.getTableData({page: this.current, pageSize: this.pageSize,
	    keyword: this.keyword, check_status: this.check_status,
	    doctor_status: this.doctor_status, department: this.department,
		  professional: this.professional,
	    cooperation_company_id: this.company_id,
	  });
	},
	async getTableData1(params) {
	  this.loading1=true;
	  let result = await this.$http.post('/doctor/doctorImportRead', params);
	  if (result.data.status===1) {
	    this.loading1 = false;
	    this.total1 = result.data.data.count;
	    let data = result.data.data;
	    let temp = [];
	    data.forEach((item) => {
	      let obj = {
	        line: item.line,
			sex: item.sex,
	        user_realname: item.user_realname,
	        mobile: item.mobile,
	        hospital: item.hospital,
	        department_name: item.department_name,
	        professional_name: item.professional_name,
			 promoter_mobiles: item.promoter_mobiles,
			error_msg:item.error_msg,
			error:item.error,
	      };
	      temp.push(obj);
	    });
	    this.data1 = temp;
		this.current=1;
		this.getTableData({page: this.current, pageSize: this.pageSize,
		  keyword: this.keyword, check_status: this.check_status,
		  doctor_status: this.doctor_status, department: this.department,
		  professional: this.professional,
						cooperation_company_id: this.company_id,
		});
	  }
	},
	importShow(){
		this.data1=[]
		this.ImportReadhospitalVisible=true
	},
	onCancel1(){
		this.ImportReadhospitalVisible=false
	},
    // 导入医生列表
    async importDoctors(event){
		
      console.log('importDoctors -> event', event);
      if(event.file.response&&event.file.response.status===0){
        this.$message.warning(event.file.response.msg);
      }
      if(event.file.response&&event.file.response.status===1){
        let id=event.file.response.data.id;
		const loading = this.$loading({
		          lock: true,
		          text: 'Loading',
		          spinner: 'el-icon-loading',
		          background: 'rgba(0, 0, 0, 0.7)'
		        });
        let res=await this.$http.post('/doctor/importDoctor', {id,cooperation_company_id: this.company_id});
        console.log('importDoctors -> res', res);
		loading.close();
        if(res.data.status===1){
			this.successNum=res.data.data.successNum
			 this.failNum=res.data.data.failNum
			  this.hadNum=res.data.data.hadNum
          this.getTableData1({page: this.current, pageSize: this.pageSize,
            id: id,
          });
          this.$message.success('操作成功！');

        }

      }
    },
	async xiazai(){
		window.open(`${this.uploadUrl}/fileup/downLoadImportExcel?name=doctor&token=${this.token}`);
	},
    // 编辑或新增
    async editAndAdd(record) {
      this.visible=true;
      if(!record){
        this.title='新增医生';
        this.id=undefined;
        this.$nextTick(()=>{
          this.$refs.formRef.$refs.basicForm.form.resetFields();
        });
      }else{
        this.title='编辑医生';
        this.id=record.id;
        let result=await this.$http.post('/promoter/getPromotersList', {id: record.id});
        if(result.data.status===1){
          this.hospital_id=record.data.hospital_id;
          let data={
            hospital_id: record.data.hospital,
            user_realname: record.data.user_realname,
            user_nickname: record.data.user_nickname,
            promoters: result.data.data.data_list.map((item)=>{return item.promoter_id;}),
            sex: record.data.sex,
            provinceCity: {province: record.data.province_id, city: record.data.city_id},
            mobile: record.data.mobile,
            address: record.data.address,
            hospital: record.data.hospital,
            speciality: record.data.speciality,
            department_id: String(record.data.department_id),
            professional_id: record.data.professional_id,
          };
          this.$nextTick(()=>{
            this.$refs.formRef.$refs.basicForm.form.resetFields();
            this.$refs.formRef.$refs.basicForm.form.setFieldsValue(data);
          });
        }

      }
    },
    // 确定编辑或新增
    onSubmit() {
      this.$refs.formRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          console.log('onSubmit -> values', values);
          if (!err) {
            if(typeof(values.hospital_id)==='string'){
              values.hospital=values.hospital_id;
              values.hospital_id= this.hospital_id;
            }
            values.province_id=values.provinceCity?values.provinceCity.province:'';
            values.city_id=values.provinceCity?values.provinceCity.city:'';
            values.path=`0,${values.provinceCity?values.provinceCity.province:''},${values.provinceCity?values.provinceCity.city:''}`;
            values.promoters=values.promoters.join();
            this.btnIsLoading=true;
            console.log('onSubmit -> values', values);
            let result=await this.$http.post('/doctor/update', {type: this.type, id: this.id, ...values,cooperation_company_id: this.company_id});
            this.btnIsLoading=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData({page: this.current, pageSize: this.pageSize,
                keyword: this.keyword, check_status: this.check_status,
                doctor_status: this.doctor_status, department: this.department,
                professional: this.professional,
				cooperation_company_id: this.company_id,
              });
              this.visible = false;
            }
          }
        },
      );
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 查看关联推广数量
    async handleList(record){
      this.visiblePromote=true;
      let result=await this.$http.post('/task/doctorTask', {doctor_id: record.id, page: 1, pageSize: 100});
      if(result.data.status===1){
        this.promoteData=result.data.data.data_list;
      }
    },
    // 关闭查看关联推广数量
    onCancelPromote(){
      this.visiblePromote=false;
    },
    // 查看关联推广员
    async handlePromoters(record){
      this.visiblePromoters=true;
      let result=await this.$http.post('/promoter/getPromotersList', {id: record.id, page: 1, pageSize: 10});
      if(result.data.status===1){
        this.promotersData=result.data.data.data_list;
      }
    },
    // 关闭查看关联推广员
    onCancelPromoters(){
      this.visiblePromoters=false;
    },
    // 查看积分
    async handleScore(record){
      this.visibleScore=true;
      this.doctor_id=record.id;
      let result=await this.$http.post('/doctor/getUserScore', {doctor_id: record.id, page: 0, pageSize: 0});
      if(result.data.status===1){
        this.scoreData=result.data.data.data_list;
      }
    },
    // 关闭查看积分
    onCancelScore(){
      this.visibleScore=false;
    },
    // 查看认证
    handleApprove(record){
      this.id=record.id;
      this.approveData=record;
      if(record.data.sex===0){
        this.approveData.sex='保密';
      }
      if(record.data.sex===1){
        this.approveData.sex='男';
      }
      if(record.data.sex===2){
        this.approveData.sex='女';
      }
      this.approveData.qualification_type=record.data.qualification_type;
      this.approveData.qualifications_url=record.data.qualifications_url;
      this.approveData.qualifications_two_url=record.data.qualifications_two_url;
      this.visibleApprove=true;
    },
    // 确认认证
    async onSubmitApprove(){
      this.$refs.approveRef.$refs.basicForm.form.validateFields(
        async(err, values) => {
          if (!err) {
            this.btnIsLoadingApprove=true;
            let result=await this.$http.post('/doctor/chackStatus', {id: this.id, ...values});
            this.btnIsLoadingApprove=false;
            if(result.data.status===1){
              this.$message.success('操作成功！');
              this.getTableData({page: this.current, pageSize: this.pageSize,
                keyword: this.keyword, check_status: this.check_status,
                doctor_status: this.doctor_status, department: this.department,
                professional: this.professional,
				        cooperation_company_id: this.company_id,
              });
              this.visibleApprove=false;
            }
          }});

    },
    // 取消认证
    onCancelApprove(){
      this.visibleApprove=false;
    },
    // 禁用 启用
    async onConfirm(record) {
      let result=await this.$http.post('doctor/canChange', {id: record.id, user_status: record.user_status===1?0:1});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData({page: this.current, pageSize: this.pageSize,
          keyword: this.keyword, check_status: this.check_status,
          doctor_status: this.doctor_status, department: this.department,
          professional: this.professional,
		      cooperation_company_id: this.company_id
        });

      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData({page: this.current, pageSize: this.pageSize,
        keyword: this.keyword, check_status: this.check_status,
        doctor_status: this.doctor_status, department: this.department,
        professional: this.professional,
		cooperation_company_id: this.company_id
      });

    },
  },
};
</script>
<style lang="scss" scoped>
/deep/.yc .ant-table-tbody > tr > td{
  padding: 10px 4px !important;
	}
  /deep/.yc .ant-table-thead > tr > th, .ant-table-tbody > tr > td{
		padding-left: 4px!important;
    padding-right: 4px!important;
	}
</style>
